import { FaUser, FaLock, FaMoneyBill } from "react-icons/fa";
import { BsGrid3X3Gap } from "react-icons/bs";
import { GoSettings } from "react-icons/go";
import { AiOutlineBell, AiOutlineQuestionCircle } from "react-icons/ai";
import { FaListOl } from "react-icons/fa";
import users from "../../assets/images/users.svg"
import packages from "../../assets/images/package.svg"
import setting from "../../assets/images/settings.svg"
import wallet from "../../assets/images/wallet.svg"
import transaction from "../../assets/images/transactions.svg"
import operator from "../../assets/images/operator.svg"
import support from "../../assets/images/ticket_management.svg";
import subuser from "../../assets/images/subuser.svg"
export const sidemenuContast = [
    {
        path: "/",
        name: "Dashboard",
        icon: <BsGrid3X3Gap />,
        Permissions:"OVERVIEW",
        role:["ROLE_ADMIN"],
    },
    {
        path: "/users",
        name: "Users",
        icon: <img src={users}></img>,
        exact: true,
        id: "Users",
        Permissions:"USERS",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/retailerList",
                name: "Manage Retailer ",
                icon: <img src = {subuser} className="user_icon"></img>,
                Permissions:"MANAGE_RETAILER",
                role:["ROLE_ADMIN"],
            },
            {
                path: "/usersList",
                name: "Manage Users ",
                icon: <img src = {subuser} className="user_icon"></img>,
                Permissions:"MANAGE_USERS",
                role:["ROLE_ADMIN"],
                
             
            },
            {
                path: "/referral-users",
                name: "Manage Referral Users",
                icon: <img src = {subuser} className="user_icon"></img>,
                Permissions:"MANAGE_RETAILER",
                role:["ROLE_ADMIN"],
            },


       
            {
                path: "/permisionManagement",
                name: "Manage View",
                icon: <FaUser />,
                Permissions:"ROLE_PERMISSION_UI",
                role:["ROLE_ADMIN"]
            },

          
            {
                path: "/ApiPermisionManagement",
                name: "Manage Api",
                icon: <FaUser />,
                Permissions:"ROLE_PERMISSION_API",
               role:["ROLE_ADMIN"]

            },
        ],
    },
    // {
    //     path: "",
    //     name: "TRAVEL",
    //     icon: <img src={users}></img>,
    //     exact: true,
    //     id: "users",
    //     Permissions:"TRAVEL",
    //     role:["ROLE_ADMIN"],
    //     subRoutes: [
    //         {
    //             path: null,
    //             name: "HOTEL",
    //             icon: <img src = {subuser} className="user_icon"></img>,
    //             Permissions:"MANAGE_USERS",
    //             role:["ROLE_ADMIN"],
    //             childRoutes: [
    //                 {
    //                     path: "/hotel/hotellist",
    //                     name: "Hotels",
    //                     icon: <FaUser />,
    //                     permissions: "MANAGE_USERS",
    //                     role: ["ROLE_ADMIN"],
    //                 },
    //                 {
    //                     path: "/hotel/cities",
    //                     name: "Cities",
    //                     icon: <FaUser />,
    //                     permissions: "MANAGE_USERS",
    //                     role: ["ROLE_ADMIN"],
    //                 },
    //                 {
    //                     path: "/hotel/countries",
    //                     name: "Countries",
    //                     icon: <FaUser />,
    //                     permissions: "MANAGE_USERS",
    //                     role: ["ROLE_ADMIN"],
    //                 },]
    //         },
    //         {
    //             path: "/flight",
    //             name: "Flight",
    //             icon: <img src = {subuser} className="user_icon"></img>,
    //             Permissions:"MANAGE_USERS",
    //             role:["ROLE_ADMIN"],
    //             childRoutes: [
    //                 {
    //                     path: "/flight/airlinesList",
    //                     name: "Airlines",
    //                     icon: <FaUser />,
    //                     permissions: "MANAGE_USERS",
    //                     role: ["ROLE_ADMIN"],
    //                 },
    //                 {
    //                     path: "/flight/airportList",
    //                     name: "Airport",
    //                     icon: <FaUser />,
    //                     permissions: "MANAGE_USERS",
    //                     role: ["ROLE_ADMIN"],
    //                 },
                  
    //             ]
             
    //         },
    //         {
    //             path: "/bookinglist",
    //             name: "BOOKING LIST",
    //             icon: <img src = {subuser} className="user_icon"></img>,
    //             Permissions:"",
    //             role:["ROLE_ADMIN"],
    //         },
    //     ],
    // },
   
   
    {
        path: "/PackageManagement",
        name: "Package Management",
        icon: <img src={packages}></img>,
        Permissions:"MANAGE_PACKAGE",
        role:["ROLE_ADMIN"],
        subRoutes:[
            {
                path: "/PackageMnagementList ",
                name:"Package Management List",
                icon: <FaUser />,
                Permissions:"MANAGE_PACKAGE_LIST",
                role:["ROLE_ADMIN"]
            },
            {
                path: "/CreatePackage",
                name:"ADD Package",
                icon: <FaUser />,
                Permissions:"ADD_MANAGE_PACKAGE",
               role:["ROLE_ADMIN"]
            },
            {
                path: "/services-route",
                name:"Services Route",
                icon: <FaUser />,
                Permissions:"ADD_MANAGE_PACKAGE",
               role:["ROLE_ADMIN"]
            },


        ]

    },
  
  
    {
        path: "/operators",
        name: "Operators List ",
        icon: <img src={operator}></img>,
        Permissions:"OPERATOR_LIST",
        role:["ROLE_ADMIN"]
    },
    {
        path: "/transactions",
        name: "Transactions",
        icon: <img src={transaction}></img>,
        Permissions:"TRANSACTION",
        role:["ROLE_ADMIN"]
    },
    {
        path: "/serviceList",
        name: "Services List",
        icon: <AiOutlineQuestionCircle />,
        Permissions:"",
        role:["ROLE_ADMIN"]
    },

    {
        path: "/wallet",
        name: "WALLET",
        icon: <img src={wallet}></img>,
        exact: true,
        id: "Wallet",
        Permissions:"WALLET",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/walletTransactions",
                name: "Wallet Summary ",
                icon: <FaUser />,
                Permissions:"WALLET_SUMMARY",
                role:["ROLE_ADMIN"],
            },
            {
                path: "/DebitCreditList",
                name: "Manage Debit Credit",
                icon: <FaLock />,
                Permissions:"CREDIT/DEDUCT",
                role:["ROLE_ADMIN"],
            },
           
            // {
            //     path: "/deposit",
            //     name: "Deposit",
            //     icon: <FaLock />,
            //     Permissions:"CREDIT/DEDUCT",
            //     role:["ROLE_ADMIN"],
            // },
            {
                path: "/bulk-transfer",
                name: "Bulk Transfer",
                icon: <FaLock />,
                Permissions:"PROCESS_BULK_USER_FUND",
                role:["ROLE_ADMIN"],
            },
        ],
    },


    {
        path: "Inventory",
        name: "POS ",
        icon: <img src={wallet}></img>,
        exact: true,
        id: "Inventory",
        Permissions:"POS",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/device-info",
                name: "POS Inventory List",
                icon: <img src={transaction}></img>,
                Permissions:"POS_INVENTORY",
                role:["ROLE_ADMIN"]
            },
            {
                path: "/assign-device",
                name: "POS Assigned Device",
                icon: <img src={transaction}></img>,
                Permissions:"POS_MAPPING",
                role:["ROLE_ADMIN"]
            },
        ],
    },

    {
        path: "cdm",
        name: "CDM",
        icon: <img src={wallet}></img>,
        exact: true,
        id: "cdm",
        Permissions:"CDM",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/cdm-card-nventory",
                name: "CDM Card Inventory",
                icon: <img src={transaction}></img>,
                Permissions:"CDM_ADD_INVENTORY",
                role:["ROLE_ADMIN"]
            },
            {
                path: "/cdm-assign-device",
                name: "CDM Assigned Card",
                icon: <img src={transaction}></img>,
                Permissions:"CDM_MAPPING",
                role:["ROLE_ADMIN"]
            },
        ],
    },
        {
        path: "dqr",
        name: "DQR",
        icon: <img src={wallet}></img>,
        exact: true,
        id: "dqr",
        Permissions:"DQR",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/dqr-inventory",
                name: "DQR Inventory",
                icon: <img src={transaction}></img>,
                Permissions:"DQR_INVENTORY",
                role:["ROLE_ADMIN"]
            },
            {
                path: "/dqr-assign-device",
                name: "DQR Assigned Device",
                icon: <img src={transaction}></img>,
                Permissions:"DQR_MAPPING",
                role:["ROLE_ADMIN"]
            },
        ],
    },
    {
        path: "/vendor",
        name: "Vendors",
        icon: <img src={users}></img>,
        exact: true,
        id: "vendor",
        Permissions:"VENDORS",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/vendor-list",
                name: "Vendors List",
                icon: <FaUser />,
                Permissions:"WALLET_SUMMARY",
                role:["ROLE_ADMIN"],
            },
            {
                path: "/vendor-transaction",
                name: "Vendor Transaction",
                icon: <img src={transaction}></img>,
                Permissions:"WALLET_SUMMARY",
                role:["ROLE_ADMIN"],
            },
           
         
            {
                path: "/vendor-fund-request",
                name: "Manage Fund Request",
                icon: <FaLock />,
                role:["ROLE_ADMIN"]
            },
        ],
    },
    // {
    //     path: "/Rental-manager",
    //     name: "Rental Management",
    //     icon: <img src={users}></img>,
    //     exact: true,
    //     id: "Rentalmanager",
    // Permissions:"RENTAL_MANAGER",
    //     role:["ROLE_ADMIN"],
    //     subRoutes: [
    //         {
    //             path: "/Rental-manager",
    //             name: "Tenant List",
    //             icon: <FaUser />,
    //             Permissions:"RENTAL_MANAGER_LIST",
    //             role:["ROLE_ADMIN"],
    //         },
    //         {
    //             path: "/pg-list",
    //             name: "PG List",
    //             icon: <FaUser />,
    //             Permissions:"PG_LIST",
    //             role:["ROLE_ADMIN"],
    //         },
            
           
    //     ],
    // },
    
    {
        path: "/b2c-users",
        name: "B2C Users",
        icon: <img src={users}></img>,
        exact: true,
        id: "b2cusers",
        Permissions:"B2C_USERS",
        role:["ROLE_ADMIN"],
        subRoutes: [
            {
                path: "/b2c-users",
                name: "B2C User List",
                icon: <FaUser />,
                Permissions:"WALLET_SUMMARY",
                role:["ROLE_ADMIN"],
            },
            {
                path: "/b2c-transaction",
                name: "B2C Transaction",
                icon: <img src={transaction}></img>,
                Permissions:"WALLET_SUMMARY",
                role:["ROLE_ADMIN"],
            },
           
        ],
    },
    {
        path: "/settings",
        name: "Settings",
        icon: <img src={setting}></img>,
        exact: true,
        id: "Settings",
        role:["ROLE_ADMIN"],
        Permissions:"SETTINGS",
        subRoutes: [
            {
                path: "/changePassword",
                name: "Change Password ",
                icon: <FaUser />,
                Permissions:"CHANGE_PASSWORD",
                role:["ROLE_ADMIN"]
            },

            // {
            //     path: "/holdbalance",
            //     name: "Hold Balance",
            //     icon: <FaLock />,
            //     Permissions:"HOLD_BALANCE"
            // },
            // {
            //     path: "/rechargecommission",
            //     name: "Recharge Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"RECHARGE_COMMISSION"
            // },
            // {
            //     path: "/bbpsrechargecommision",
            //     name: "BBPS Recharge Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"BBPS_RECHARGE_COMMISSION"
            // },
            // {
            //     path: "/billpaycommision",
            //     name: "Bill Pay Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"BILL_PAY_COMMISSION"
            // },
            // {
            //     path: "/aepscommission",
            //     name: "AEPS Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"AEPS_COMMISSION"
            // },
            // {
            //     path: "/adharpaycomission",
            //     name: "Adhar Pay Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"ADHAR_PAY_COMMISSION"
            // },
            // {
            //     path: "/adharpaysetting",
            //     name: "Adhar Pay Setting",
            //     icon: <FaMoneyBill />,
            //     Permissions:"ADHAR_PAY_SETTING"
            // },
            // {
            //     path: "/aepscommission",
            //     name: "AEPS Commission",
            //     icon: <FaMoneyBill />,
            //     Permissions:""
            // },
            // {
            //     path: "/expresspayoutsurcharge",
            //     name: "Express Payout Surcharge",
            //     icon: <FaMoneyBill />,
            //     Permissions:"EXPRESS_PAYOUT_SURCHARGE"
            // },
            // {
            //     path: "/expresspayoutcomission",
            //     name: "Express Payout Commissione",
            //     icon: <FaMoneyBill />,
            //     Permissions:"EXPRESS_PAYOUT_COMMISSION"
            // },
            // {
            //     path: "/payoutsurcharge",
            //     name: "Payout Surcharge",
            //     icon: <FaMoneyBill />,
            //     Permissions:"PAYOUT_SURCHARGE"
            // },
            // {
            //     path: "/uttpansurcharge",
            //     name: "UTT Pan Surcharge",
            //     icon: <FaMoneyBill />,
            //     Permissions:"UTT_SURCHARGE"
            // },
            // {
            //     path: "/uttpancouponsurcharge",
            //     name: "UTT Pan coupon Surcharge",
            //     icon: <FaMoneyBill />,
            //     Permissions:"UTT_COUPON_SURCHARGE"
            // },
            // {
            //     path: "/upisurcharge",
            //     name: "UPI Surcharge",
            //     icon: <FaMoneyBill />,
            //     Permissions:"UPI_SURCHARGE"
            // },
            // {
            //     path: "/upicomission",
            //     name: "UPI Comission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"UPI_COMMISSION"
            // },
            // {
            //     path: "/slider",
            //     name: "Slider",
            //     icon: <FaMoneyBill />,
            //     Permissions:"SLIDER"
            // },
            // {
            //     path: "/news",
            //     name: "News",
            //     icon: <FaMoneyBill />,
            //     Permissions:"NEWS"
            // },                

            // {
            //     path: "/rechargeplan",
            //     name: "Recharge Plan",
            //     icon: <FaMoneyBill />,
            //     Permissions:"RECHARGE_PLAN"

            // },
            // {
            //     path: "/ministatementcomission",
            //     name: "Mini Statement Comission",
            //     icon: <FaMoneyBill />,
            //     Permissions:"MINI_STATEMENT_COMMISSION"
            // },
            // {
            //     path: "/memberidplan",
            //     name: "Member Id Plan",
            //     icon: <FaMoneyBill />,
            //     Permissions:"MEMBER_ID_PLAN"
            // },
            // {
            //     path: "/movetomember",
            //     name: "Move To Member",
            //     icon: <FaMoneyBill />,
            //     Permissions:"MOVE_TO_MEMBER"
            // },
            // {
            //     path: "/statemaster",
            //     name: "State Master",
            //     icon: <FaMoneyBill />,
            //     Permissions:"STATE_MASTER"
            // },
            // {
            //     path: "/citymaster",
            //     name: "City Master",
            //     icon: <FaMoneyBill />,
            //     Permissions:"CITY_MASTER"
            // },

        ],
    },

    {
        path: "/support",
        name: "Support Management",
        icon: <img src={support}></img>,
        exact: true,
        id: "ticketmanagement",
        role:["ROLE_ADMIN"],
        Permissions:"SUPPORT_MANAGEMENT",
        subRoutes: [
            {
                path: "/ticketList",
                name: "Ticket Management",
                icon:  <img src={support}></img>,
                Permissions:"CHANGE_PASSWORD",
                role:["ROLE_ADMIN"]
            },
        

        ],
    },
    {
        path: "/reports",
        name: "Reports",
        icon: <GoSettings />,
        exact: true,
        id: "Reports",
        role:["ROLE_ADMIN"],
        subRoutes: [


            {
                path: "/report/analyse",
                name: "Analyse Report",
                icon: <FaUser />,
                Permissions:"EXP_REPORTS"
            },
            {
                path: "report/tid",
                name: "Terminal Report",
                icon: <FaUser />,
                Permissions:"EXP_REPORTS"
            },
            {
                path: "/transaction/logs",
                name: "Transaction Logs",
                icon: <FaUser />,
                Permissions:"EXP_REPORTS"
            },

          


        ],
    },
    

    {
        path: "/helpandsupport",
        name: "Help & Support",
        icon: <AiOutlineQuestionCircle />,
    },

    // {
    //     path: "/logout",
    //     name: "Logout",
    //     icon: <FiLogOut />,
    // },
];